/**
 * Industry, profession and field of study on the member profile.
 *
 * The options live in hogc-one-api's database (`industry_option`,
 * `profession_option`, `field_of_study_option`) and come from
 * `GET /v2/profile/career-field-options` — see the `lookups` store module. The
 * profile stores the chosen option's id. The option marked `isOther` opens a
 * "please specify" text box.
 */

// The string is the contract with hogc-one-api (PROFILE_CAREER_FIELDS_FLAG).
export const PROFILE_CAREER_FIELDS_FLAG = 'profile-career-fields';

export const OTHER_CAREER_FIELD_MAX_LENGTH = 80;

export const CAREER_FIELD_KEYS = [
  'industryId',
  'otherIndustry',
  'professionId',
  'otherProfession',
  'fieldOfStudyId',
  'otherFieldOfStudy',
];

/**
 * The levels of study (`levelrank` ids) that ask for a field of study:
 * Polytechnic 4, ITE 23, Full-time Undergraduate 5 and Post-graduate 28. The
 * ids are not in education order, so this is a list, not a range.
 */
export const FIELD_OF_STUDY_LEVEL_IDS = [4, 23, 5, 28];

/**
 * Which of the three a stage of life (and, when Studying, a level of study)
 * asks for. A field that does not apply keeps its stored value — it is hidden,
 * not cleared, so moving from Studying to Working and back loses nothing.
 */
export const careerFieldsForStage = (stageOfLife, levelId = null) => ({
  fieldOfStudyId: stageOfLife === 'STUDYING' && FIELD_OF_STUDY_LEVEL_IDS.includes(Number(levelId)),
  industryId: stageOfLife === 'WORKING',
  professionId: stageOfLife === 'WORKING',
});

/**
 * The six fields as the API takes them. The API drops free text that does not
 * belong to an "Others" option, so it needs no options list here.
 */
export const careerFieldsPayload = source =>
  Object.fromEntries(
    CAREER_FIELD_KEYS.map(key => {
      const value = source[key];
      return [key, typeof value === 'string' ? value.trim() || null : value || null];
    }),
  );
